import { useState, useEffect } from 'react';
import { reactLocalStorage } from "reactjs-localstorage";

export const getUserInfo = function () {
    return null
}

export const getCourtTypeObj = reactLocalStorage.get('cmsTopCourtCourtTypeObj')
export const setCourtTypeObj = function(data) {
    reactLocalStorage.setObject('cmsTopCourtCourtTypeObj', data);
    return true
}

export const getDashboardWizardPosition = reactLocalStorage.get('dashboardWizardPosition')
export const setDashboardWizardPosition = function(data) {
    reactLocalStorage.setObject('dashboardWizardPosition', data);
    return true
}
export const deleteDashboardWizardPosition = function (data) {
    reactLocalStorage.remove('dashboardWizardPosition', data);
    return true
}

export const getMerchantWizardPosition = reactLocalStorage.get('merchantWizardPosition')
export const setMerchantWizardPosition = function(data) {
    reactLocalStorage.setObject('merchantWizardPosition', data);
    return true
}
export const deleteMerchantWizardPosition = function (data) {
    reactLocalStorage.remove('merchantWizardPosition', data);
    return true
}

export const getPlayerFilter = reactLocalStorage.get('playerFilter')
export const setPlayerFilter = function(data) {
    reactLocalStorage.setObject('playerFilter', data);
    return true
}
export const deletePlayerFilter = function(data) {
    reactLocalStorage.remove('playerFilter', data);
    return true
}

export const deleteCurrLocalStorage = function (data) {
    deleteDashboardWizardPosition()
    deleteMerchantWizardPosition()
    deletePlayerFilter()
    return true
}

function useLocalStorage(key, initialValue = 0) {
  const [value, setValue] = useState(() => {
    // run once on init
    if (typeof window === 'undefined') return initialValue;
    const stored = reactLocalStorage.get(key) || null;
    console.log('here stored', stored)
    return stored ? JSON.parse(stored) : initialValue;
  });
    return value
}

export { useLocalStorage };
export const getCourtPlace = () => {
    return reactLocalStorage.getObject('courtPlace');
}
export const setCourtPlace = function(data) {
    reactLocalStorage.setObject('courtPlace', data);
    return true
}